const STORAGE_MEDIA_BASE = 'https://firebasestorage.googleapis.com/v0/b/innoture-alc-trust.firebasestorage.app/o/';

export const storageImage = (filename) =>
  `${STORAGE_MEDIA_BASE}${encodeURIComponent(`site-assets/${filename}`)}?alt=media`;
